<template>
    <div>
        <el-row>
            <el-col :span="24" >
                <div class="show-title">
                    历年真题
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="10" :offset="7">
                <div class="box-card"  v-for="(item, index) in list" :key="index">
                    <el-card style="padding:0 30px;">
                        <el-row>
                            <el-col :span="9">
                                <div class="category-name">{{item.work_name}}</div>
                                <div class="work-count">
                                    <i class="el-icon-user-solid"></i>
                                    {{item.learn_count}} 人已学习
                                </div>
                            </el-col>
                            <el-col :span="15">
                                <div class="click-btn">
                                    <el-button v-if="item.report_list_flag == 'Y'" @click="viewReport(item)" round>查看报告</el-button>
                                    <el-button type="primary" @click="testStart(item)" round>{{item.complete_flag == 'N' ? '开始测试' : '重新测试'}}</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>

</script>


<script>
    import { realQuestionsList} from '@/api'
    import store from '@/store'
    export default {
        name: 'YearsList',
        props: ['cate', 'words'],
        data() {
            return {
                list:[],
                form:{
                    page: 1,
                    limit: 99,
                    work_second_category_id: -1
                },
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            realQuestionsList()
            {
                realQuestionsList(this.form).then(response => {
                    this.list = response.data
                })
            },
            testStart(e)
            {
                this.$router.push({path:'/homeworkanswer',query: {work_guid:e.work_guid}})

            },
            viewReport(e)
            {
                this.$router.push({path:'/viewreport',query: {work_guid:e.work_guid}})
            },
            loginout()
            {
                store.dispatch('user/logout');
            }
        },
        
        mounted() {
            this.form.work_second_category_id = this.$route.query.category_id 
            var res = "";
            this.realQuestionsList()
        }
    }
</script>
<style scoped lang="less">
    .show-title{
        font-size: 28px;
        text-align: center;
        padding: 3vh 0 3vh 0;
    }
    .box-card{
        padding:1vh;
        margin-bottom:1vh;
    }
    .category-name{
        font-size:20px;
        color:#409EFF;
        margin-top:1vh;

    }
    .work-count{
        font-size: 20px;
        margin-top: 30px;
        color:#E6A23C
    }
    .click-btn{
        margin-top:45px;
        text-align: right;
    }
</style>
